import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { ImmoTask } from 'src/app/model/immo-task/immo-task';
import LoggedAction from 'src/app/model/logged-action';

export class ImmoIPPlacerImmoTaskFunctions {
  private constructor() {}

  static setImmoTaskExecutedRegistration: ImmoTaskEditFunction<LoggedAction> = (
    immoTask: ImmoTask,
    executedRegistration: LoggedAction
  ) => {
    immoTask.executedRegistration = executedRegistration;
  };

  static removeDeletedAssets: ImmoTaskEditFunction<string[]> = (
    immoTask: ImmoTask,
    deletedUuids: string[]
  ) => {
    if (
      !CollectionHelper.isPopulated(immoTask.assets) ||
      !CollectionHelper.isPopulated(deletedUuids)
    ) {
      return;
    }
    CollectionHelper.filterInPlace(
      immoTask.assets,
      a =>
        a.asset != null && deletedUuids.findIndex(d => d === a.asset.uuid) >= 0
    );
  };
}

export type ImmoTaskEditFunction<I> = (immoTask: ImmoTask, input: I) => void;
